module.exports = __webpack_public_path__ + "static/media/Header-iPhone4.fdaec412.png";